import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

function goToForm(e) {
  e.preventDefault();
  document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function ExplainSection() {
  return (
    <section data-testid="explain-section" className="mx-auto max-w-6xl px-6 py-28 sm:py-36">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="text-center"
      >
        <h2 className="mx-auto max-w-3xl font-display text-4xl font-semibold leading-[1.1] tracking-tight text-[#171512] sm:text-6xl">
          HOW CLOSE DO YOU WANT TO BE?
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#171512]/60 sm:text-lg">
          You can just be here early.
          <br />
          Or you can help decide what Nostos becomes.
        </p>
      </motion.div>

      <div className="mt-16 grid gap-10 md:grid-cols-2">
        <motion.article
          data-testid="explain-waitlist-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          whileHover={{ y: -8 }}
          transition={{ type: "spring", stiffness: 170, damping: 17 }}
          style={{
            background: "linear-gradient(160deg, #EFF6FE 0%, #E2F0FC 55%, #D5E8FA 100%)",
            boxShadow: "0 34px 70px -34px rgba(23,21,18,0.28)",
          }}
          className="relative flex flex-col overflow-hidden rounded-3xl border border-white/70 p-7 sm:p-10"
        >
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-16 -top-16 h-60 w-60 rounded-full opacity-70 blur-3xl"
            style={{ background: "#B9D6F1" }}
          />
          <span className="relative inline-block self-start rounded-full border border-[#B9D6F1] bg-white/70 px-3 py-1 font-mono text-[10px] tracking-[0.25em] text-[#171512]">
            THE WAITLIST
          </span>
          <h3 className="relative mt-5 font-serif text-[1.7rem] font-semibold leading-snug text-[#171512] sm:text-[2rem]">
            For people who want to know when we’re ready.
          </h3>
          <p className="relative mt-5 text-sm leading-[1.8] text-[#171512]/70 sm:text-base">
            Join the list to get early access to our limited first drop, and if it fills up,
            access before we open it to everyone else.
          </p>
          <p className="relative mt-6 font-serif text-lg italic text-[#171512]/80">You’re here for the launch.</p>
          <a
            href="#waitlist"
            onClick={goToForm}
            data-testid="explain-waitlist-join-button"
            className="relative mt-8 inline-block self-start rounded-full border border-[#171512]/25 bg-white/60 px-5 py-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[#171512] transition-colors duration-200 hover:border-[#171512] hover:bg-white"
          >
            join now
          </a>
        </motion.article>

        <motion.article
          data-testid="explain-founding-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          whileHover={{ y: -8 }}
          transition={{ type: "spring", stiffness: 170, damping: 17, delay: 0.1 }}
          style={{
            background: "linear-gradient(160deg, #FDEFF4 0%, #FBE3EC 50%, #F6D5E2 100%)",
            boxShadow: "0 34px 70px -34px rgba(23,21,18,0.28)",
          }}
          className="relative flex flex-col overflow-hidden rounded-3xl border border-white/70 p-7 text-[#171512] sm:p-10"
        >
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-16 -top-16 h-60 w-60 rounded-full opacity-70 blur-3xl"
            style={{ background: "#F2B7CB" }}
          />
          <span className="relative inline-block self-start rounded-full bg-[#171512] px-3 py-1 font-mono text-[10px] font-bold tracking-[0.25em] text-[#F7DEE4]">
            THE FOUNDING COMMUNITY
          </span>
          <h3 className="relative mt-5 font-serif text-[1.7rem] font-semibold leading-snug sm:text-[2rem]">
            For people who want a say in what we build.
          </h3>
          <div className="relative mt-5 space-y-4 text-sm leading-[1.8] text-[#171512]/75 sm:text-base">
            <p>The first 200 people who choose this become part of our Founding Community.</p>
            <p>
              You’ll get a unique founding number and a seat at the table when we’re deciding what
              makes it into Nostos: what stays, what goes, what gets better.
            </p>
            <p>
              You’ll also be first in line for future drops, founding-member discounts, and
              invitations to our community events.
            </p>
          </div>
          <p className="relative mt-6 font-serif text-lg italic text-[#171512]/85">
            You’re not just waiting for Nostos. You’re helping shape it.
          </p>
          <a
            href="/founding"
            data-testid="explain-founding-perks-link"
            className="relative mt-6 inline-block font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-[#171512] underline-offset-4 hover:underline"
          >
            see what members get
          </a>
          <a
            href="#waitlist"
            onClick={goToForm}
            data-testid="explain-founding-join-button"
            className="relative mt-8 inline-block self-start rounded-full bg-[#171512] px-5 py-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[#FDFBF6] transition-colors duration-200 hover:bg-white hover:text-[#171512]"
          >
            join now
          </a>
        </motion.article>
      </div>
    </section>
  );
}
